export const KIWI = "KIWI"

export default { KIWI }
